import articleCategoryService from "@/services/article-category.service.js";

const state = {
    currentCategory: [],
    article_categories: []
}

const mutations = {
    SET_ARTICLE_CATEGORIES(state, data){
        state.article_categories = data;
    },
    SET_CURRENT_ARTICLE_CATEGORY(state, data){
        state.currentCategory = state.article_categories.find(c => c.id === data);
    },
}

const actions = {
    async fetchArticleCategories({ commit }){
        try {
            let response = await articleCategoryService.getAll();
            commit('SET_ARTICLE_CATEGORIES', response.data);
        } 
        catch (error) {
            console.log(error.response.status);
        }
    },
    setCurrentArticleCategory({commit}, categoryId){
        commit("SET_CURRENT_ARTICLE_CATEGORY", categoryId)
    },
}

const getters = {
    getArticleCategories(){
        return state.article_categories;
    },
    getArticleCategoryById: (state) => (categoryId) => {
        return state.article_categories.find(c => c.id == categoryId);
    }, 
}

export default {
    state,
    mutations,
    actions,
    getters
}